<template>
  <v-flex xs12>
        <v-btn
        color="primary"
        dark
        @click="$router.push({name: 'RegieCreate'})"
      >Neuer Bericht</v-btn>
    <v-data-table
        :headers="headers"
        :items="REGIE_INDEX"
        class="elevation-1"
        v-bind:pagination.sync="pagination"
        loading="true"
    >
        <template slot="items" slot-scope="props">
          <tr @click="open(props.item.id)">
            <td>{{ props.item.date }}</td>
            <td>{{ props.item.customer }}</td>
            <td>{{ props.item.project }}</td>
          </tr>
        </template>
        <template slot="no-data">
            <p>Es gibt noch keine Einträge für diese Position</p>
        </template>
    </v-data-table>
  </v-flex>

</template>

<script>
import { mapGetters } from 'vuex'
import { REGIE_INDEX } from '../../store/actions/regie'
export default {
  data () {
    return {
      headers: [
        {
          text: 'Datum',
          align: 'left',
          value: 'timestamp'
        },
        {
          text: 'Kunde',
          value: 'customer'
        },
        {
          text: 'ProjeKt',
          value: 'project'
        }
      ],
      pagination: {
        sortBy: 'timestamp',
        descending: true,
        rowsPerPage: 25
      }
    }
  },
  computed: {
    ...mapGetters([
      REGIE_INDEX
    ])
  },
  mounted () {
    this.$store.dispatch(REGIE_INDEX)
  },
  methods: {
    open (id) {
      this.$router.push({ name: 'RegieEdit', params: { id: id } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Regie/Index.vue